import { Fields } from '../types/Fields';

export function mergeFields<TObject extends object>(fieldsList: Array<Fields<TObject>>): Fields<TObject> {
    const fieldsSet = new Set<keyof TObject>([]);
    for (const fields of fieldsList) {
        for (const field of fields) {
            fieldsSet.add(field);
        }
    }
    return Array.from(fieldsSet).sort();
}
